<!--
 * @Description: 列表筛选工具栏
-->
<template>
  <div class="filter-container">
    <template
      :key="index"
      v-for="(item, index) in filterData"
    >
      <el-input
        v-if="!item.isSelect"
        v-model="item.model"
        :placeholder="t(item.placeholder)"
        style="width: 200px"
        class="filter-item"
        @keyup.enter="handleFilter"
      />
      <el-select
        v-if="item.isSelect"
        v-model="item.model"
        :placeholder="t(item.placeholder)"
        clearable
        style="width: 120px"
        class="filter-item"
      >
        <el-option
          v-for="(optionItem, optionIndex) in item.selectOption"
          :key="optionIndex"
          :label="t(optionItem.label)"
          :value="optionItem.value"
        />
      </el-select>
    </template>

    <el-button
      v-waves
      class="filter-item"
      style="margin-left: 10px"
      type="primary"
      icon="el-icon-search"
      @click="handleFilter"
    >
      {{ t("table.search") }}
    </el-button>
    <el-button
      v-if="hasCreate"
      class="filter-item"
      style="margin-left: 10px"
      type="primary"
      icon="el-icon-edit-outline"
      @click="handleCreate"
    >
      {{ t("table.add") }}
    </el-button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    filterData: {
      type: Array,
      default: () => []
    },
    hasCreate: {
      type: Boolean,
      default: true
    }
  },
  emits: ['create', 'search'],
  setup(props, contex) {
    const { t } = useI18n()
    const handleFilter = () => {
      contex.emit('search')
    }
    const handleCreate = () => {
      contex.emit('create')
    }
    return {
      t,
      handleFilter,
      handleCreate
    }
  }
})

</script>

<style lang="scss" scoped>
.svg-color{
  fill: white;
}
</style>
